interface CardSummaryProps {
    children: React.ReactNode;
    className?: string; // Additional custom classes for styling
}

const CardSummary: React.FC<CardSummaryProps> = ({
    children,
    className = "",
}) => {
    return (
        <div
            className={`rounded-md border border-gray-200 bg-white ${className}`}
        >
            {/* Card Body */}
            <div className="p-0 border-gray-100">
                <div className="space-y-6">{children}</div>
            </div>
        </div>
    );
};

export default CardSummary;
